import StandardRestError from './Standard'

class TrialProjectLimitError extends StandardRestError {
  static CODE = 'TRIAL_PROJECT_LIMIT'

  constructor(
    message = 'Your trial includes one case.',
    status = 422,
    body = {},
  ) {
    super(message)
    this.status = status
    this.body = body
  }
}

export default TrialProjectLimitError
